import { Typography } from '@mui/material';
import {
  ListButton,
  Show,
  Tab,
  TabbedShowLayout,
  TabbedShowLayoutTabs,
  TopToolbar,
  useRecordContext,
  useShowController,
} from 'react-admin';
import { UserDetails } from 'src/models';

import { CloseUserActionButton } from './CloseUserActionButton';
import { ForgotPasswordActionButton } from './ForgotPasswordActionButton';
import { LinkAdditionalAccountActionButton } from './LinkAdditionalAccountActionButton';
import { PostcloseOfferInvestUserActionButton } from './PostcloseOfferInvestUserActionButton';
import { UserDetailsTab } from './UserDetailsTab';

const UserDetailsPageActions = () => {
  const record = useRecordContext<UserDetails>();

  const rootAccount = record?.accounts?.find(account => account.isRoot);

  return (
    <TopToolbar>
      {rootAccount && <LinkAdditionalAccountActionButton rootAccount={rootAccount} accounts={record.accounts} />}
      <PostcloseOfferInvestUserActionButton />
      <ForgotPasswordActionButton />
      <CloseUserActionButton />
      <ListButton />
    </TopToolbar>
  );
};

const Title = () => {
  const { firstName, lastName, email } = useRecordContext<UserDetails>();

  return (
    <Typography variant='h6'>
      User:{' '}
      <strong>
        {firstName} {lastName}
      </strong>{' '}
      ({email})
    </Typography>
  );
};

export const UserShow = () => {
  const { record } = useShowController<UserDetails>();

  return (
    <Show emptyWhileLoading title={<Title />} actions={<UserDetailsPageActions />}>
      <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant='scrollable' />}>
        {record && (
          <Tab label='User' sx={{ overflow: 'auto' }}>
            <UserDetailsTab id={record.id} />
          </Tab>
        )}
      </TabbedShowLayout>
    </Show>
  );
};
